import { accessToken } from "./sessionKey";

//@ts-ignore
import { AxiosInstance, API_ROOT } from "@careinfo/axios-service";

let instance: any;

// Initialize the instance before making any API calls
const initInstance = async () => {
  if (!instance) {
    instance = await AxiosInstance();
  }
};
// Get data from API
export const getApiData = async (url, param = null) => {
  await initInstance();
  let response;
  try {
    response = await instance({
      method: "GET",
      url: `${url}`,
      params: param,
      transformResponse: [
        function (responseData) {
          // Do whatever you want to transform the data
          return JSON.parse(responseData);
        },
      ],
    });
  } catch (e) {
    return e.response;
  }
  return response;
};

// Post data to API
export const postApiData = async (data) => {
  const { url, formData, setError, responseType = "json" } = data;
  await initInstance();
  let response;

  try {
    response = await instance({
      method: "POST",
      url: `${url}`,
      data: formData,
      responseType, // 👈 'json' (default) or 'blob'
      headers: {
        Authorization: `JWT ${accessToken()}`,
      },
      // Only apply transformResponse for non-blob responses
      ...(responseType === "json" && {
        transformResponse: [
          function (responseData) {
            return JSON.parse(responseData);
          },
        ],
      }),
    });
  } catch (e) {
    for (const key in e.response?.data) {
      if (e.response?.data.hasOwnProperty(key)) {
        setError?.(key, { type: "custom", message: e.response?.data[key] });
      }
    }
    return e.response;
  }

  return response;
};

// export const postApiBlobData = async (data) => {
//   const { url, formData, setError, responseType = "json" } = data;
//   await initInstance();
//   let response;

//   try {
//     response = await instance({
//       method: "POST",
//       url: `${url}`,
//       data: formData,
//       responseType,
//       headers: {
//         Authorization: `JWT ${accessToken()}`,
//       },
//       ...(responseType === "json" && {
//         transformResponse: [
//           function (responseData) {
//             return JSON.parse(responseData);
//           },
//         ],
//       }),
//     });
//   } catch (e) {
//     for (const key in e.response?.data) {
//       if (e.response?.data.hasOwnProperty(key)) {
//         setError?.(key, { type: "custom", message: e.response?.data[key] });
//       }
//     }
//     return e.response;
//   }

//   return response;
// };

export const deleteApiData = async (data: any) => {
  const { url, formData, setError } = data;
  await initInstance();
  let response;

  try {
    response = await instance({
      method: "DELETE",
      url: `${url}`,
      headers: {
        Authorization: `JWT ${accessToken()}`,
      },
      transformResponse: [
        function (responseData: any) {
          // Only parse if responseData exists (204 has no content)
          return responseData ? JSON.parse(responseData) : null;
        },
      ],
    });

    // Handle 204 No Content explicitly
    if (response.status === 204) {
      return { success: true, message: "Deleted successfully", data: null };
    }

    return { success: true, data: response.data };
  } catch (e: any) {
    if (e.response?.data && typeof e.response.data === "object") {
      for (const key in e.response.data) {
        if (Object.prototype.hasOwnProperty.call(e.response.data, key)) {
          setError?.(key, {
            type: "custom",
            message: e.response.data[key],
          });
        }
      }
    }

    console.error(e.response);
    return {
      success: false,
      status: e.response?.status || 500,
      error: e.response?.data || "Unknown error occurred",
    };
  }
};

// Update data
export const patchApiData = async (data) => {
  const { url, formData, setError } = data;
  await initInstance();
  let response;
  try {
    response = await instance({
      method: "PATCH",
      url: `${url}`,
      data: formData,
      headers: {
        Authorization: `JWT ${accessToken()}`,
      },
      transformResponse: [
        function (responseData) {
          // Do whatever you want to transform the data
          return JSON.parse(responseData);
        },
      ],
    });
  } catch (e) {
    for (const key in e.response?.data) {
      if (e.response?.data.hasOwnProperty(key)) {
        setError(key, { type: "custom", message: e.response?.data[key] });
      }
    }
    return e.response;
  }
  return response;
};
// create form data to upload files
export const patchApiFormData = async (data: any) => {
  const { url, formData, setError } = data;
  let response;
  await initInstance();
  try {
    response = await instance({
      method: "PATCH",
      url: `${url}`,
      data: formData,
      headers: {
        "Content-Type": `multipart/form-data`,
      },
      transformResponse: [
        function (responseData: any) {
          //Do whatever you want to transform the data
          return JSON.parse(responseData);
        },
      ],
    });
  } catch (e: any) {
    for (const key in e.response?.data) {
      if (e.response?.data.hasOwnProperty(key) && setError) {
        setError(key, { type: "custom", message: e.response?.data[key] });
      }
    }
    return e.response;
  }
  return response;
};
export const postApiChunkFormData = async (data: any) => {
  const { url, formData, setProgress, chunkIndex, totalChunks } = data;
  let response;
  await initInstance();
  try {
    response = await instance({
      method: "POST",
      url: `${url}`,
      data: formData,
      maxContentLength: Infinity,
      maxBodyLength: Infinity,
      headers: {
        "Content-Type": `multipart/form-data`,
      },
      onUploadProgress: (progressEvent) => {
        const percentCompleted = Math.round(
          ((chunkIndex + 1) / totalChunks) * 100
        );
        setProgress(percentCompleted);
      },
      transformResponse: [
        function (responseData: any) {
          //Do whatever you want to transform the data
          return JSON.parse(responseData);
        },
      ],
    });
  } catch (e: any) {
    return e.response;
  }
  return response;
};

export { API_ROOT };
